<mat-card class="__card  c-soft-elevation">
  <div class="__grid">

    <div class="__grid-item">

      <div *transloco="let t; read: 'exceptions'">

        <div>{{ t(data.code) || t('UNKNOWN_ERROR', { key: data.key}) }}</div>

      </div>

      @if (data.originalError?.error?.error?.meta?.length) {
        @for (meta of data.originalError?.error?.error?.meta; let index = $index; track index) {
          <div
            class="__meta">
            @if (meta.parameter) {
              <span>{{ meta.parameter }}</span>
            }
            @if (meta.parameter) {
              -
            }
            @if (meta.message) {
              <span>{{ meta.message }}</span>
            }
          </div>
        }
      }

    </div>

    <div class="u-text--right  __grid-item">
      <button
        class="__button"
        mat-button
        type="button"
        (click)="instance.closeWithAction()">
        {{ state.translations?.close }}
      </button>
    </div>

  </div>
</mat-card>
